const URLScheme = 'heartlinev3'

export default {
  closeCallview: `${URLScheme}://callview/close`
}
